import { render, staticRenderFns } from "./AssignmentRuleSentenceBuilder.vue?vue&type=template&id=52b3520d&scoped=true&"
import script from "./AssignmentRuleSentenceBuilder.vue?vue&type=script&lang=js&"
export * from "./AssignmentRuleSentenceBuilder.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentRuleSentenceBuilder.vue?vue&type=style&index=0&id=52b3520d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3520d",
  null
  
)

export default component.exports